<ul class="list">
  <ng-container *ngFor="let item of list; let i = index">
    <li *ngIf="!shouldBeHidden(i)" [ngClass]="{
      'has-tick': shouldBeTicked(i)
    }">{{item}}</li>
  </ng-container>
</ul>
